import { render } from "./NotFound.vue?vue&type=template&id=753673bd&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import "./NotFound.vue?vue&type=style&index=0&id=753673bd&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-753673bd"

export default script